import { TRIGGER_READY_TO_CLOSE_REASONS } from './constants';
/**
 * What, if anything, to tell someone whose call's room was closed under them.
 *
 * A Malka call's room closes when the call ends: the other person hung up
 * (the apps end the room for everyone, which Jitsi reports as "The meeting
 * has been terminated") or the server closed it ("The call ended."). Either
 * way the call has simply ended, and nothing is said (Robert, 2026-09-28).
 * A closed lobby still says so.
 *
 * @param {unknown} reason - The reason the room was destroyed with.
 * @returns {string|undefined} The lang key of the notice, or none.
 */
export function destroyedRoomNoticeKey(reason) {
    return reason === TRIGGER_READY_TO_CLOSE_REASONS['lobby.lobbyClosed'] ? 'lobby.lobbyClosed' : undefined;
}
